import { GabaritoAdsQuestionElement } from "./interface";

export function createInterstitial(
    adPath: string,
    questionConfig: GabaritoAdsQuestionElement
): void {
    const timeoutDuration = 5;
    const modalContainer = document.createElement('div');
    modalContainer.id = 'intersticial-modal';
    modalContainer.dataset.adUnitPath = adPath;

    const adPlacementArea = document.createElement('div');
    adPlacementArea.className = 'ad-placement-area-dynamic';

    const buttonPlaceholder = document.createElement('div');
    buttonPlaceholder.className = 'close-placeholder';

    let secondsRemaining = timeoutDuration;
    buttonPlaceholder.textContent = `Poderá sair em ${secondsRemaining}s`;

    let localCloseEnableTimerId: number | null = null;
    let localCountdownIntervalId: number | null = null;

    modalContainer.appendChild(adPlacementArea);
    modalContainer.appendChild(buttonPlaceholder);
    document.body.appendChild(modalContainer);
    document.body.style.overflow = 'hidden';

    localCloseEnableTimerId = window.setTimeout(() => {
        if (document.body.contains(modalContainer)) {
            const closeButton = document.createElement('button');
            closeButton.innerHTML = 'Sair';
            closeButton.setAttribute('aria-label', 'Sair');
            closeButton.className = 'close-button';

            closeButton.onclick = () => {
                if (localCloseEnableTimerId) clearTimeout(localCloseEnableTimerId);
                if (localCountdownIntervalId) clearInterval(localCountdownIntervalId);
                if (typeof window.Sg_GPT_onTriggerRemoveCallback === 'function') {
                    window.Sg_GPT_onTriggerRemoveCallback(adPlacementArea, [modalContainer.dataset.adUnitPath || '']);
                }
                modalContainer.remove();
                document.body.style.overflow = 'auto';
            };

            if (document.body.contains(buttonPlaceholder)) {
                buttonPlaceholder.replaceWith(closeButton);
            }
        }

        if (localCountdownIntervalId) clearInterval(localCountdownIntervalId);
        localCloseEnableTimerId = null;
        if (document.body.contains(modalContainer)) {
            (modalContainer as any).closeEnableTimerId = null;
            (modalContainer as any).countdownIntervalId = null;
        }
    }, secondsRemaining * 1000);

    (modalContainer as any).closeEnableTimerId = localCloseEnableTimerId;

    localCountdownIntervalId = window.setInterval(() => {
        secondsRemaining--;
        if (secondsRemaining >= 0) {
            if (document.body.contains(buttonPlaceholder)) {
                buttonPlaceholder.textContent = `Poderá sair em ${secondsRemaining}s`;
            }
        }
        if (secondsRemaining < 0) {
            if (localCountdownIntervalId) clearInterval(localCountdownIntervalId);
            localCountdownIntervalId = null;
            if (document.body.contains(modalContainer)) {
                (modalContainer as any).countdownIntervalId = null;
            }
        }
    }, 1000);

    (modalContainer as any).countdownIntervalId = localCountdownIntervalId;

    const isMC = questionConfig.type === 'multiple-choice';
    const containerClass = isMC ? 'gabarito-ads__container--interstitial' : 'hidden-content-ad__container--interstitial';
    const overlayId = `ad-${isMC ? questionConfig.dataId : 'hc-' + questionConfig.checkboxSelector?.substring(1)}`;

    if (typeof window.Sg_GPT_onTriggerCallback === 'function') {
        window.Sg_GPT_onTriggerCallback(
            { adUnit: adPath, classes: 'ad-unit ad-unit--pt-br' },
            { target: adPlacementArea, classes: containerClass, containerId: overlayId }
        );
    }
}

export function createOverlay(
    adPath: string,
    targetAnswerElement: HTMLElement,
    questionWrapperElement: HTMLElement,
    questionConfig: GabaritoAdsQuestionElement
): void {
    const isMC = questionConfig.type === 'multiple-choice';
    const overlayClass = isMC ? 'gabarito-ads__overlay' : 'hidden-content-ad__overlay';
    const containerClass = isMC ? 'gabarito-ads__container' : 'hidden-content-ad__container';
    const overlayId = `ad-${isMC ? questionConfig.dataId : 'hc-' + questionConfig.checkboxSelector?.substring(1)}`;

    targetAnswerElement.style.cssText = 'position: relative; min-height: 425px;';

    if (typeof window.Sg_GPT_onTriggerCallback === 'function') {
        window.Sg_GPT_onTriggerCallback(
            { adUnit: adPath, classes: containerClass },
            { target: targetAnswerElement, classes: overlayClass, containerId: overlayId }
        );
    }

    setTimeout(() => {
        const overlayElement = document.getElementById(overlayId) || questionWrapperElement.querySelector('.' + overlayClass);
        const adContainerElement = overlayElement?.querySelector('.' + containerClass);

        if (overlayElement && adContainerElement) {
            const buttonDelay = 5000;
            let secondsRemaining = buttonDelay / 1000;

            const timedButton = document.createElement('button');
            timedButton.className = 'gabarito-ads__button';
            timedButton.textContent = `Aguarde ${secondsRemaining} segundos para ver a resposta`;
            timedButton.disabled = true;
            timedButton.setAttribute('data-track-click', 'cta-see-answer-gabarito-ad');

            const removeAdsLink = document.createElement('a');
            removeAdsLink.href = '/tmplus/';
            removeAdsLink.textContent = 'Estudar sem anúncios';
            removeAdsLink.className = 'gabarito-ads__remove-ads';
            removeAdsLink.setAttribute('data-track-click', 'cta-remove-ads-gabarito-ad');

            let buttonEnableTimerId: number | null = null;
            let countdownIntervalId: number | null = null;
            let labelEnableTimerId: number | null = null;
            let hiddenContentCheckbox: HTMLInputElement | null = null;

            if (questionConfig.type === 'hidden-content' && questionConfig.checkboxSelector) {
                hiddenContentCheckbox = document.querySelector(questionConfig.checkboxSelector) as HTMLInputElement;
                if (hiddenContentCheckbox) {
                    hiddenContentCheckbox.disabled = true;
                    labelEnableTimerId = window.setTimeout(() => {
                        if (hiddenContentCheckbox && document.body.contains(hiddenContentCheckbox)) {
                            hiddenContentCheckbox.disabled = false;
                        }
                        labelEnableTimerId = null;
                        if (document.body.contains(overlayElement)) {
                            (overlayElement as any).labelEnableTimerId = null;
                        }
                    }, buttonDelay);
                    (overlayElement as any).labelEnableTimerId = labelEnableTimerId;
                }
            }

            timedButton.onclick = () => {
                if (timedButton.disabled) return;

                if (buttonEnableTimerId) clearTimeout(buttonEnableTimerId);
                if (countdownIntervalId) clearInterval(countdownIntervalId);
                if (labelEnableTimerId) {
                    clearTimeout(labelEnableTimerId);
                    if (hiddenContentCheckbox && document.body.contains(hiddenContentCheckbox)) {
                        hiddenContentCheckbox.disabled = false;
                    }
                }

                if (typeof window.Sg_GPT_onTriggerRemoveCallback === 'function') {
                    window.Sg_GPT_onTriggerRemoveCallback(overlayElement, [adPath]);
                }

                targetAnswerElement.style.cssText = '';

                if (typeof window.Sg_GPT_onTriggerRemoveCallback !== 'function' || !window.Sg_GPT_onTriggerRemoveCallback(overlayElement, [adPath])) {
                    if (document.body.contains(overlayElement)) {
                        overlayElement.remove();
                    }
                }
            };

            buttonEnableTimerId = window.setTimeout(() => {
                if (document.body.contains(timedButton)) {
                    timedButton.textContent = 'Ver Resposta';
                    timedButton.disabled = false;
                    timedButton.classList.add('gabarito-ads__button--enabled');
                }

                if (countdownIntervalId) clearInterval(countdownIntervalId);
                buttonEnableTimerId = null;
                if (document.body.contains(overlayElement)) {
                    (overlayElement as any).closeTimerId = null;
                }
            }, buttonDelay);

            (overlayElement as any).closeTimerId = buttonEnableTimerId;

            countdownIntervalId = window.setInterval(() => {
                secondsRemaining--;
                if (secondsRemaining > 0) {
                    if (document.body.contains(timedButton)) {
                        timedButton.textContent = `Aguarde ${secondsRemaining} segundos para ver a resposta`;
                    }
                } else {
                    if (countdownIntervalId) clearInterval(countdownIntervalId);
                    countdownIntervalId = null;
                    if (document.body.contains(overlayElement)) {
                        (overlayElement as any).countdownIntervalId = null;
                    }
                    if (document.body.contains(timedButton) && !timedButton.disabled) {
                        timedButton.textContent = 'Ver Resposta';
                    }
                }
            }, 1000);

            (overlayElement as any).countdownIntervalId = countdownIntervalId;

            overlayElement.appendChild(adContainerElement);
            overlayElement.appendChild(removeAdsLink);
            overlayElement.appendChild(timedButton);
        }
    }, 150);
}